import { PROBLEM_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherProblemStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="problem"
      title="What problems do you need help with?"
      options={PROBLEM_OPTIONS}
      stepName="matcher_problem_step"
    />
  );
}

export { MatcherProblemStep };
